<template>
	<div>
		<h1>{{msg}}</h1>
	</div>
</template>

<script>
	export default{
		name:'navigation',
		data(){
			return {
				
			}
		},
		props:['msg']
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/comm/navigation.vue